/* import __COLOCATED_TEMPLATE__ from './block-preview.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();